/*
 * @Description: 完税证明
 * @Date: 2025-06-19 09:45:57
 */
import { route } from './src/router';

const name = 'tax-payment-certificate';
export { name, route };
